import axios from 'axios';
import { getEnvironment } from '@global/helpers';
const Config = getEnvironment();

const baseUrl = Config.MS_B2B_ACCOUNTS_API_URL;

const login = (payload) => {
  return axios.post(`${baseUrl}/auth/login`, payload);
};

const forgetPassword = (payload) => {
  return axios.post(`${baseUrl}/users/forget-password`, payload);
};

const resetPassword = (payload) => {
  return axios.post(`${baseUrl}/users/set-password`, payload);
};

const logout = () => {
  return axios.post(`${baseUrl}/auth/logout`);
};

const userMe = () => {
  return axios.get(`${baseUrl}/users/me`);
};

const userMenu = () => {
  return axios.get(`${baseUrl}/menus`);
};

const changePassword = (payload) => {
  return axios.post(`${baseUrl}/users/change-password`, payload);
};

export const MsAuth = {
  login,
  logout,
  userMe,
  userMenu,
  changePassword,
  forgetPassword,
  resetPassword,
};
